import React from 'react';

import CheckBox from 'components/CheckBox';

import './styles.css';

const CheckList = ({items}) => (
  <div className="CheckList">
    {items.map((item, index) => (
      <CheckBox
        key={index}
        className="checkListItem"
        name={item.name}
        label={item.label}
        defaultChecked={item.defaultChecked}
      />
    ))}
  </div>
);

export default CheckList;
